import { Flex, TextVariant, Text } from '@mprolab/uikit'
import * as React from 'react'
import UseAnimations from 'react-useanimations'
import loading from 'react-useanimations/lib/loading'
import styled, { useTheme } from 'styled-components'

interface IAppProps {
  label: string
  value: number
  valueType?: string
  valueColor?: string
  labelColor?: string
  boldLabel?: boolean
  isLoading: boolean
}

const TableRow = styled(Flex)`
  justify-content: space-between;
`

const AutostakeRowInfo: React.FC<IAppProps> = ({
  label,
  value,
  valueType = '',
  valueColor,
  labelColor,
  boldLabel,
  isLoading
}) => {
  const { colors } = useTheme()
  return (
    <TableRow>
      <Text variant={boldLabel ? TextVariant.BODY_SMALL_BOLD : TextVariant.BODY_SMALL} color={labelColor}>
        {label}
      </Text>
      {isLoading ? (
        <Flex>
          <UseAnimations animation={loading} size={16} strokeColor={colors.white3} />
        </Flex>
      ) : (
        <Text variant={TextVariant.BODY_SMALL_BOLD} color={valueColor}>
          {value} {valueType}
        </Text>
      )}
    </TableRow>
  )
}

export default AutostakeRowInfo
